import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import OutGoingRequestAppointmentCard from "../../../../components/requests/OutGoingRequestAppointmentCard";
import { makeApiRequest, showApiErrorMessages } from "../../../../helpers";
import RequestsModel from "../../../../api/models/RequestsModel";
import { ApiResponse } from "../../../../api/apiResponse";
import { GetNewStudentRequest } from "../../../../api/endpoints/candidate/requests";

export const OutGoingTab = () => {
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  const [requests, setRequests] = useState<RequestsModel[] | null>([]);
  const getNewStudents = () => {
    makeApiRequest(
      () => GetNewStudentRequest(),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] = RequestsModel.fromApiResponse(
            data?.result,
            "receiver"
          );
          setRequests(requestsList);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };
  useEffect(() => {
    getNewStudents();
  }, []);
  return (
    <div className="w-full bg-white px-8 py-6">
      <div className="flex flex-col gap-6">
        {!!requests &&
          requests?.map((request) => (
            <OutGoingRequestAppointmentCard request={request} />
          ))}
      </div>
    </div>
  );
};
